import { useSearchParams } from "react-router-dom";
import { StaffFirmProfileForm } from "./StaffFirmProfileForm";

export function FirmProfileNew() {
  const [params] = useSearchParams();
  // Pre-populate company when navigated from FirmDetail's "create profile" CTA.
  const initialCompanyId = params.get("companyId") ?? undefined;
  return <StaffFirmProfileForm mode="create" initialCompanyId={initialCompanyId} />;
}

export default FirmProfileNew;
